import { Unit, UnitBaseTypes } from "../../Units";

function KilopoundPerSquaredFoot() {
  return (
    <>
      <Unit unit={UnitBaseTypes.ksf} />
    </>
  );
}

export default KilopoundPerSquaredFoot;
